/**
 * Created by ed on 2/10/17.
 */
import React, { Component } from 'react';
import classNames from 'classnames';

class WizardAncestryLevel extends Component {

    constructor() {
        super();
        this.state = {
            levels: [
                {
                    name: 'Parents'
                },
                {
                    name: 'Grandparents'
                },
            ],
        };
        this.changeToLevel = this.changeToLevel.bind(this);
    }

    // adds "Great " to each level beyond Grandparents
    renderLevel(level) {
        let i = level;
        let levels = this.state.levels;
        if (i>1) {
            let j = i-2;
            let prefix = '';
            for (let c = 0; c <= j; c++) {
                prefix += 'Great ';
            }
            return prefix + levels[1].name;
        }
        return levels[i].name;
    }

    changeToLevel() {
        this.props.changeToLevel(this.props.value);
    }

    render() {
        let level = this.renderLevel(this.props.value);

        let classes = classNames({
            'ancestor': true,
            'active': this.props.current,
            'complete' : this.props.hasValue(this.props.value)
        });

        return (
            <li className={classes}><a href="" onClick={this.changeToLevel}><h5>{level}</h5></a></li>
        );
    }
}

export default WizardAncestryLevel;


// WEBPACK FOOTER //
// ./src/components/WizardAncestryLevel.js